import { createElement } from 'react';
import { Icon } from '../../Icon/Icon.js';
import { CheckboxItem, ItemIndicator } from '@radix-ui/react-dropdown-menu';
import { useItemStyling } from './Item.js';

const Checkbox = props => {
  const {
    checked,
    children,
    onChange,
    ...otherProps
  } = props;
  const className = useItemStyling({
    disabled: props.disabled,
    indented: true,
    className: props.className
  });
  return createElement(CheckboxItem, Object.assign({}, otherProps, {
    className: className,
    checked: checked,
    onCheckedChange: onChange
  }), createElement(ItemIndicator, {
    className: "absolute left-0 ml-1.5"
  }, createElement(Icon, {
    name: "tick",
    className: "-ml-px !h-4 !w-4"
  })), children);
};

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
